import { render, staticRenderFns } from "./tabChangeChargeBpm.vue?vue&type=template&id=65bdbc9e&"
import script from "./tabChangeChargeBpm.vue?vue&type=script&lang=js&"
export * from "./tabChangeChargeBpm.vue?vue&type=script&lang=js&"
import style0 from "./tabChangeChargeBpm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65bdbc9e')) {
      api.createRecord('65bdbc9e', component.options)
    } else {
      api.reload('65bdbc9e', component.options)
    }
    module.hot.accept("./tabChangeChargeBpm.vue?vue&type=template&id=65bdbc9e&", function () {
      api.rerender('65bdbc9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/ChangeChargeVerify/tabChangeChargeBpm.vue"
export default component.exports